import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import { Alert, AlertTitle } from '@material-ui/lab';
import red from '@material-ui/core/colors/red';
import { Box } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  root: {
    paddingTop: theme.spacing(1),
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
    height: '100%'
  },
  alert_container: {
    width: '100%',
    '& > * + *': {
      marginTop: theme.spacing(1)
    }
  },
  alert_title: {
    color: red['900']
  }
}));

const StickyAlert = ({ title, messages }) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <div className={classes.alert_container}>
            {messages.map(({ id, message, render }) => (
              <Alert severity="error" key={id} icon={false}>
                <AlertTitle className={classes.alert_title}>{title}</AlertTitle>
                <Box component="div" whiteSpace="break-spaces">
                  {render ? render() : message}
                </Box>
              </Alert>
            ))}
          </div>
        </Grid>
      </Grid>
    </div>
  );
};

StickyAlert.propTypes = {
  title: PropTypes.string.isRequired,
  messages: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      message: PropTypes.string,
      render: PropTypes.func
    })
  ).isRequired
};

export default StickyAlert;
